<template>
  <div style="display: flex">
    <el-radio
      v-model="flexBtn"
      label="2"
    >
      悬浮于页面底部
    </el-radio>
    <el-radio
      v-model="flexBtn"
      label="1"
    >
      按顺序排列
    </el-radio>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export const cssTransition = () => {
  return {}
}
export default {
  name: 'SpFlexBtn',
  mixins: [mixin],
  props: {},
  data () {
    return {
      flexBtn: '1'
    }
  },

  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
</style>
